import { z } from 'zod';

export const formOptionSchema = z.object({
  id: z.number().int().positive().optional(),
  option: z.string().min(1).max(100),
  order: z.number().int(),
  locale: z.record(z.string(), z.string()).optional(),
  score: z.number().int(),
  form_question_id: z.number().int().positive().optional(),
});
export type FormOptionInput = z.infer<typeof formOptionSchema>;
